import { useEffect, useRef } from "react";

const MouseCursor = () => {
  const innerRef = useRef(null);
  const outerRef = useRef(null);

  useEffect(() => {
    const moveCursor = (e) => {
      const { clientX: x, clientY: y } = e;
      if (innerRef.current && outerRef.current) {
        innerRef.current.style.left = `${x}px`;
        innerRef.current.style.top = `${y}px`;
        outerRef.current.style.left = `${x}px`;
        outerRef.current.style.top = `${y}px`;
      }
    };

    const addHover = () => {
      innerRef.current.classList.add("cursor-hover");
      outerRef.current.classList.add("cursor-hover");
    };
    const removeHover = () => {
      innerRef.current.classList.remove("cursor-hover");
      outerRef.current.classList.remove("cursor-hover");
    };

    const hoverElems = document.querySelectorAll("a, button, .hover-target");
    hoverElems.forEach((el) => {
      el.addEventListener("mouseenter", addHover);
      el.addEventListener("mouseleave", removeHover);
    });

    window.addEventListener("mousemove", moveCursor);
    // hiển thị con trỏ
    innerRef.current.style.visibility = "visible";
    outerRef.current.style.visibility = "visible";

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      hoverElems.forEach((el) => {
        el.removeEventListener("mouseenter", addHover);
        el.removeEventListener("mouseleave", removeHover);
      });
    };
  }, []);

  return (
    <>
      <div
        ref={outerRef}
        className="mouse-cursor cursor-outer"
      ></div>
      <div
        ref={innerRef}
        className="mouse-cursor cursor-inner"
      ></div>
    </>
  );
};

export default MouseCursor;
